import request from 'shared/lib/request';
import { API } from 'shared/constants';
import qs from 'qs';
import _ from 'lodash';

const getAllOptions = (tipo, filters, orderBy) => {
  let filter = [
    {
      type: 'eq',
      field: 'tipo',
      value: tipo || null,
    },
  ];

  if (filters) {
    if (tipo && typeof filters === 'string') {
      filter = [
        {
          type: 'eq',
          field: 'tipo',
          value: tipo || null,
        },
        {
          type: 'like',
          field: 'nome',
          value: `${filters}%`,
        },
      ];
    } else if (!tipo && typeof filters === 'string') {
      filter = [
        {
          type: 'like',
          field: 'nome',
          value: `${filters}%`,
        },
      ];
    } else if (!tipo && filters.constructor === Array) { // Is an array
      filter = filters;
    }
  }

  return request(
    {
      url: API.LIST_ITEM,
      method: 'GET',
      params: {
        filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    })
    .then((data) => mapper(data, orderBy));
};

const mapper = (data, orderBy = 'asc') => ({
  options: _.orderBy(data._embedded.list_item.map((item) => ({ // eslint-disable-line
    value: item.id,
    label: item.nome,
    tipo: item.tipo,
  })), ['label'], [orderBy]),
});

export const ProfessioneService = {
  getAllOptions: getAllOptions.bind(this, 'professione'),
};

export const StatoCivileService = {
  getAllOptions: getAllOptions.bind(this, 'stato_civile'),
};

export const DestinazioneService = {
  getAllOptions: getAllOptions.bind(this, 'destinazione'),
};

export const MotivazioniAVCService = {
  getAllOptions: getAllOptions.bind(
    this,
    null,
    [{
      type: 'eq',
      field: 'tipo',
      value: 'blocco_avc',
    },
    {
      type: 'eq',
      field: 'tipo',
      value: 'sblocco_avc',
      where: 'or',
    }]
  ),
};

export const MotivazioniDDService = {
  getAllOptions: getAllOptions.bind(
    this,
    null,
    [{
      type: 'eq',
      field: 'tipo',
      value: 'blocco_dd',
    },
    {
      type: 'eq',
      field: 'tipo',
      value: 'sblocco_dd',
      where: 'or',
    }]
  ),
};

export const TipoContrattoCollaboratoreService = {
  getAllOptions: getAllOptions.bind(this, 'tipo_contratto_collaboratore'),
};

export const ConsapService = {
  getAllOptions: getAllOptions.bind(this, 'consap', null, 'desc'),
};

export const CittadinanzaService = {
  getAllOptions: getAllOptions.bind(this, 'cittadinanza_italiana', null, 'desc'),
};



// WEBPACK FOOTER //
// ./app/shared/services/api/listitem/index.js